/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { inquiryControllerAnswer } from '../fn/inquiry/inquiry-controller-answer';
import { InquiryControllerAnswer$Params } from '../fn/inquiry/inquiry-controller-answer';
import { inquiryControllerCreate } from '../fn/inquiry/inquiry-controller-create';
import { InquiryControllerCreate$Params } from '../fn/inquiry/inquiry-controller-create';
import { inquiryControllerDelete } from '../fn/inquiry/inquiry-controller-delete';
import { InquiryControllerDelete$Params } from '../fn/inquiry/inquiry-controller-delete';
import { inquiryControllerFindById } from '../fn/inquiry/inquiry-controller-find-by-id';
import { InquiryControllerFindById$Params } from '../fn/inquiry/inquiry-controller-find-by-id';
import { inquiryControllerSearch } from '../fn/inquiry/inquiry-controller-search';
import { InquiryControllerSearch$Params } from '../fn/inquiry/inquiry-controller-search';
import { inquiryControllerSearchMyInquiries } from '../fn/inquiry/inquiry-controller-search-my-inquiries';
import { InquiryControllerSearchMyInquiries$Params } from '../fn/inquiry/inquiry-controller-search-my-inquiries';
import { InquiryDto } from '../models/inquiry-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class InquiryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `inquiryControllerSearch()` */
  static readonly InquiryControllerSearchPath = '/api/inquiry';

  /**
   * 문의 목록 조회 (관리자).
   *
   * 관리자가 전체 문의 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inquiryControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryControllerSearch$Response(params: InquiryControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = inquiryControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 문의 목록 조회 (관리자).
   *
   * 관리자가 전체 문의 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inquiryControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryControllerSearch(params: InquiryControllerSearch$Params, context?: HttpContext): Observable<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.inquiryControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `inquiryControllerCreate()` */
  static readonly InquiryControllerCreatePath = '/api/inquiry';

  /**
   * 문의 등록 (사용자).
   *
   * 사용자가 문의를 등록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inquiryControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inquiryControllerCreate$Response(params: InquiryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = inquiryControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 문의 등록 (사용자).
   *
   * 사용자가 문의를 등록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inquiryControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inquiryControllerCreate(params: InquiryControllerCreate$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.inquiryControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `inquiryControllerAnswer()` */
  static readonly InquiryControllerAnswerPath = '/api/inquiry/{id}/answer';

  /**
   * 문의 답변 (관리자).
   *
   * 관리자가 문의에 답변합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inquiryControllerAnswer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inquiryControllerAnswer$Response(params: InquiryControllerAnswer$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = inquiryControllerAnswer(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 문의 답변 (관리자).
   *
   * 관리자가 문의에 답변합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inquiryControllerAnswer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inquiryControllerAnswer(params: InquiryControllerAnswer$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.inquiryControllerAnswer$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `inquiryControllerFindById()` */
  static readonly InquiryControllerFindByIdPath = '/api/inquiry/{id}';

  /**
   * 문의 상세 조회.
   *
   * 문의 상세 정보를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inquiryControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryControllerFindById$Response(params: InquiryControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<InquiryDto>> {
    const obs = inquiryControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 문의 상세 조회.
   *
   * 문의 상세 정보를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inquiryControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryControllerFindById(params: InquiryControllerFindById$Params, context?: HttpContext): Observable<InquiryDto> {
    const resp = this.inquiryControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InquiryDto>): InquiryDto => r.body)
    );
  }

  /** Path part for operation `inquiryControllerDelete()` */
  static readonly InquiryControllerDeletePath = '/api/inquiry/{id}';

  /**
   * 문의 삭제 (관리자).
   *
   * 관리자가 문의를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inquiryControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryControllerDelete$Response(params: InquiryControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = inquiryControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 문의 삭제 (관리자).
   *
   * 관리자가 문의를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inquiryControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryControllerDelete(params: InquiryControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.inquiryControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `inquiryControllerSearchMyInquiries()` */
  static readonly InquiryControllerSearchMyInquiriesPath = '/api/inquiry/my';

  /**
   * 내 문의 목록 조회 (사용자).
   *
   * 사용자가 본인이 작성한 문의 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inquiryControllerSearchMyInquiries()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryControllerSearchMyInquiries$Response(params: InquiryControllerSearchMyInquiries$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = inquiryControllerSearchMyInquiries(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 내 문의 목록 조회 (사용자).
   *
   * 사용자가 본인이 작성한 문의 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inquiryControllerSearchMyInquiries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryControllerSearchMyInquiries(params: InquiryControllerSearchMyInquiries$Params, context?: HttpContext): Observable<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.inquiryControllerSearchMyInquiries$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

}
